__turbopack_context__.v({
  "blue": "GlowingIcon-module-scss-module__mcHHMG__blue",
  "container": "GlowingIcon-module-scss-module__mcHHMG__container",
  "green": "GlowingIcon-module-scss-module__mcHHMG__green",
  "orange": "GlowingIcon-module-scss-module__mcHHMG__orange",
  "pink": "GlowingIcon-module-scss-module__mcHHMG__pink",
});
